
<!--
* An app message pop up with a <slot> element as it's content
*
* @param {boolean} isOpen - Whether the pop up is open
* @param {string} title - Title to use for the pop up
* @param {Object[]} buttons - Buttons array of objects for buttons in popup footer
* @param {string} button.text - Text to show in button
* @param {ButtonTypes} button.type - Type of button
* @param {ButtonStates} button.state - State of button
*
* @fires MsAppMessage#updatedIsOpen
* @fires MsAppMessage#buttonClick
-->

<!--
* Update is open prop event.
*
* @event MsAppMessage#updateIsOpen
-->

<!--
* button click event.
*
* @event MsAppMessage#buttonClick
-->

<template>
  <div
    class="modal"
    :class="{ 'is-active': isOpen }">
    <div
      class="modal-background"
      @click="close" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button
          class="delete"
          aria-label="close"
          @click="close"/>
      </header>
      <section class="modal-card-body">
        <slot></slot>
      </section>
      <footer class="modal-card-foot">
        <app-button
          class="modal-card-foot-button"
          v-for="(button, index) in messageButtons"
          :key="index"
          :text="$t(button.text)"
          :type="button.type"
          :state="button.state"
          @click.native="buttonClick(button)" />
      </footer>
    </div>
  </div>
</template>

<script>
  import AppButton, {ButtonTypes, ButtonStates} from '@/components/app-button'

  export const defaultModalButtons = {
    YES: {
      'type': ButtonTypes.PRIMARY,
      'state': ButtonStates.ENABLED,
      'id': 'yes'
    },
    NO: {
      'type': ButtonTypes.TERTIARY,
      'state': ButtonStates.ENABLED,
      'id': 'no'
    }
  }

  export default {
    name: 'MsAppMessage',
    components: {
      AppButton
    },
    props: {
      isOpen: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      buttons: {
        type: [Object, Array]
      }
    },
    computed: {
      messageButtons () {
        return this.buttons ? this.buttons : null
      }
    },
    methods: {
      /**
       * Emits update event for isOpen
       */
      close: function () {
        this.$emit('update:isOpen', false)
      },

      /**
       * Emits button click event
       *
       * @param {Object} button - Clicked button object
       */
      buttonClick: function (button) {
        this.$emit('buttonClick', button)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/sass/shared.scss";

  // Needed to fix modal not sitting central in ie 11
  // @see https://github.com/jgthms/bulma/issues/460#issuecomment-382603864
  .modal {
    flex-direction: column;
  }

  // Have to overwrite bulmas max-height: calc(100vh - 40px)
  // as vh doesn't take into consideration mobile url bars
  .modal-card {
    max-height: calc(100% - 40px);
    overflow: auto;
  }

  .modal-card-title {
    font-weight: $bold-font-weight;
    // max must be reduced by some right padding for close button
    max-width: calc(100% - #{$dims-padding-default});
  }

  .modal-card-foot {
    display: flex;
    justify-content: space-between;
    padding: 0 $dims-horizontal-gutter $dims-spacing-small $dims-horizontal-gutter;
    background: $quaternary-brand-color;
  }

  .modal-card-foot-button {
    width: 49%;
    padding: $dims-spacing-small 0;
  }
</style>
